import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';

import type { LinkSectionItem } from '../types';
import Item from './Item';
import { ListItem } from './ListItem';

interface TextLinkSectionListItemProps {
  index: number;
  item: LinkSectionItem;
}

const UnstyledStyledListItem = styled(ListItem)``;

const StyledListItem = (props: ComponentProps<typeof UnstyledStyledListItem>) => (
  <UnstyledStyledListItem
    pr={['sp_16', 'sp_24', null, 'sp_32']}
    py="sp_4"
    width={[1 / 2, 1 / 4, 1 / 2, 1 / 3]}
    {...props}
  />
);

export const TextLinkSectionListItem = ({ index, item }: TextLinkSectionListItemProps) => (
  <StyledListItem data-testid={`link-section-list-item-${index}`}>
    <Item item={item}>
      <span data-testid="link-section-link-label">{item.name}</span>
    </Item>
  </StyledListItem>
);
